<template>
	<core-modal
		name="bulk-delete-modal"
		class="omapi-modal bulk-delete-modal"
		:clickToClose="!isBulkDeleting"
		:isConfirmation="true"
	>
		<modals-content>
			<form @submit.prevent="bulkDelete">
				<p>Are you sure you want to delete {{ bulk.length }} {{ makePlural('contact', bulk.length) }}.</p>

				<section class="buttons">
					<core-loading-button
						class="bulk-delete-leads"
						size="large"
						color="blue"
						buttonType="submit"
						:loading="isBulkDeleting"
						ref="toFocus"
					>
						Yes, I'm Sure
					</core-loading-button>
					<core-button
						size="large"
						@click.prevent="$modal.hide('bulk-delete-modal')"
						:disabled="isBulkDeleting"
					>
						Cancel
					</core-button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { strings } from '@/campaigns/mixins/strings'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapMutations, mapState } = createNamespacedHelpers('monsterleads')

export default {
	mixins : [ strings ],
	data () {
		return {
			isBulkDeleting : false,
		}
	},
	computed : {
		...mapState([ 'bulk' ]),
	},
	methods : {
		...mapActions([ 'deleteLead' ]),
		...mapMutations([ 'removeFromBulk' ]),
		bulkDelete () {
			this.isBulkDeleting = true

			const count = this.bulk.length
			const promises = []

			this.bulk.forEach((leadId) => {
				const promise = this.deleteLead(leadId)
					.then(() => {
						this.removeFromBulk(leadId)
					})

				promises.push(promise)
			})

			Promise.all(promises)
				.catch(e => {})
				.finally(() => {
					const deleted = count - this.bulk.length
					const message = `Successfully deleted ${deleted} ${this.makePlural('contact', deleted)}.`
					this.$store.commit('addAlert', { message, type: 'success' })
					this.isBulkDeleting = false
					this.$modal.hide('bulk-delete-modal')
				})
		},
	},
}
</script>
